import { createGetEndpoint } from '@sonar-software/sonar-http';
import { UserNotificationPreferences } from '@types';

export type GetUserNotificationPreferencesRequest = {
	userId: number;
};

export const getUserNotificationPreferences = createGetEndpoint<
	GetUserNotificationPreferencesRequest,
	UserNotificationPreferences
>((request) => `/api/v2/user/${request.userId}/notification-preferences`);
